// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/background/brands_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brands-body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 80vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
}
.brands-body .brands-row {
  /* max-width: 90% !important; */
  margin: 0 auto !important;
}
.brands-body .title {
  font-family: "Chakra Petch";
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 78px;
  /* text-align: center; */
  color: #ffffff;
}

.brands-body .first-content {
  font-family: "Chakra Petch";
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.5;
  text-transform: uppercase;
  color: #ffffff;
}

.brands-body .second-content {
  font-family: "Chakra Petch";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  text-transform: uppercase;
  color: #ffffff;
  text-align: right;
}

.brands-body .content {
  border: 1px solid #4a19ed;
  padding: 10px;
  padding-top: 6%;
}

.brands-body .slider {
  padding: 12px;
  /* width: fit-content; */
  background: linear-gradient(to right, #4dffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to right, #4dffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to left, #4dffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to left, #4dffff 0.5px, transparent 2px) 100% 100%,
    linear-gradient(to bottom, #4dffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to bottom, #4dffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to top, #4dffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to top, #4dffff 0.5px, transparent 2px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  height: 384px;
  
}

.brands-body .slider-area {
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 20px #09fffc;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  padding: 20px;
  height: 100%;
  width: 100%;
  margin-right: 22px;
  background: linear-gradient(to right, #0068e8 1px, transparent 2px),
    linear-gradient(to top, #0068e8 1px, transparent 2px);
  background-size: 16px 16px;
}

.brands-body .slider-area .description {
  font-family: "Chakra Petch";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  background-color: #0068e8;
  padding: 10px;
  width: 100%;
  border-radius: 5px;


}
@media (max-width:767px) {
  .brands-body .slider {
    height: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/components/brands.css"],"names":[],"mappings":"AAAA;EACE,yDAA8D;EAC9D,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB;;;;;;;qEAOmE;EACnE,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;;AAEf;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB;yDACuD;EACvD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,kBAAkB;;;AAGpB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".brands-body {\n  background-image: url(\"../../images/background/brands_bg.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 80vh;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.brands-body .brands-row {\n  /* max-width: 90% !important; */\n  margin: 0 auto !important;\n}\n.brands-body .title {\n  font-family: \"Chakra Petch\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 60px;\n  line-height: 78px;\n  /* text-align: center; */\n  color: #ffffff;\n}\n\n.brands-body .first-content {\n  font-family: \"Chakra Petch\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: #ffffff;\n}\n\n.brands-body .second-content {\n  font-family: \"Chakra Petch\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: #ffffff;\n  text-align: right;\n}\n\n.brands-body .content {\n  border: 1px solid #4a19ed;\n  padding: 10px;\n  padding-top: 6%;\n}\n\n.brands-body .slider {\n  padding: 12px;\n  /* width: fit-content; */\n  background: linear-gradient(to right, #4dffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to right, #4dffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to left, #4dffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to left, #4dffff 0.5px, transparent 2px) 100% 100%,\n    linear-gradient(to bottom, #4dffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to bottom, #4dffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to top, #4dffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to top, #4dffff 0.5px, transparent 2px) 100% 100%;\n  background-repeat: no-repeat;\n  background-size: 12px 12px;\n  height: 384px;\n  \n}\n\n.brands-body .slider-area {\n  border: 2px solid #ffffff;\n  box-shadow: 0px 0px 20px #09fffc;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-direction: column;\n  padding: 20px;\n  height: 100%;\n  width: 100%;\n  margin-right: 22px;\n  background: linear-gradient(to right, #0068e8 1px, transparent 2px),\n    linear-gradient(to top, #0068e8 1px, transparent 2px);\n  background-size: 16px 16px;\n}\n\n.brands-body .slider-area .description {\n  font-family: \"Chakra Petch\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  text-transform: uppercase;\n  color: #ffffff;\n  background-color: #0068e8;\n  padding: 10px;\n  width: 100%;\n  border-radius: 5px;\n\n\n}\n@media (max-width:767px) {\n  .brands-body .slider {\n    height: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
